export default "__VITE_ASSET__Dd0RHw0v__"